import React, { Component } from 'react';

class RedCards extends Component {
  render() {
    const RD_ARRAY = this.props.data;
    const TEAM = parseInt( this.props.team, 10 );

    const RDS = [];

    for(let i in RD_ARRAY){
      // eslint-disable-next-line no-unused-expressions
      RD_ARRAY[i].team === TEAM
      ? RDS.push(<span key={i} className={RD_ARRAY[i].type}></span>)
      : null;
    }

    return(
      <div className="rd_container">
        {RDS}
      </div>
    )
  }
};

export default RedCards;


// WEBPACK FOOTER //
// ./src/Components/RedCards.js